(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'RTBHouse';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("rtbhouse", TrackingModel);

        if (!Tracker || !Tracker.Properties.RtbHashCode)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        var _isUserSelectedProduct;

        Init();

        function Init() {
            if (!CanTrack) return;

                /*TRACK home*/
            if (TrackingModel.IsHomePage) {
                Track('home');
            }
            /*TRACK categorylist & productslist*/
            else if (TrackingModel.IsProductListPage || Tracker.Properties.ExtraProductListTemplateCodes.split(",").filter(function (e) { return e && e.toLowerCase() == LhApp.Context.Item.Template })[0]) {

                /*TRACK any other page*/
                if (TrackingModel.ProductListsData) {
                    var productIds = [];
                    for (var list in TrackingModel.ProductListsData) {
                        var listItems = TrackingModel.ProductListsData[list];
                        for (var i = 0; i < listItems.length; i++) {
                            var product = listItems[i];
                            var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                            if (productIds.indexOf(productId) < 0)
                                productIds.push(productId);
                        };
                    }
                    if (productIds.length > 0)
                        Track('listing_' + productIds.join(','));
                }
            }
            /*TRACK product details*/
            else if (TrackingModel.IsProductDetailsPage) {
                if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                    var product = TrackingModel.ProductData[0];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                    Track('offer_' + productId);
                }
            }
            /*TRACK checkout start*/
            else if (TrackingModel.IsCheckoutPage) {
                Track('startorder');
            }
            /*TRACK order completion*/
            else if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var productIds = [];
                var items = TrackingModel.CartProductsData;
                for (var i = 0; i < items.length; i++) {
                    var product = items[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                    if (productIds.indexOf(productId))
                        productIds.push(productId);
                }
                var trackData = 'orderstatus2';
                trackData += '_' + TrackingModel.Order.ProductsCostN;
                trackData += '_' + TrackingModel.Order.Id;
                trackData += '_' + productIds.join(',');
                trackData += '&cd=default';

                Track(trackData);
            }
            // beacuse we trackif async
            else if (!TrackingModel.IsCartPage){
                Track('ncm=1');
            }
        }

        function Track(data) {
            var url = '//creativecdn.com/tags?id=pr_' + Tracker.Properties.RtbHashCode;

            if (data == 'ncm=1')
                url = url + '&amp;' + data;
            else
                url = url + '_' + data;

            if ($('#iframeRtbHouse').length > 0)
                $('#iframeRtbHouse').remove();

            $('<iframe>').attr({ "src": url, "id": "iframeRtbHouse", "style": "display:none", "width": "1", "height": "1", "frameborder": "0" }).appendTo("body");
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            /*TRACK product view (changed)*/
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                Track('offer_' + productId);                
            });

            //TRACK add to cart (recorded by the ABOVE script)
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!TrackingModel.IsCartPage)
                    return;

                var productIds = [];
                var items = envelope.message.data.Cart.Items;
                for (var i = 0; i < items.length; i++) {
                    var product = items[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                    if (productIds.indexOf(productId))
                        productIds.push(productId);
                }
                if (productIds.length > 0)
                    Track('basketstatus_' + productIds.join(','));                
            });
        }
    });
})();